import React, { useRef, useEffect, useState} from 'react';
import './RateLimits.css'
import CodeBlock from '../../Components/Docs/CodeBlock';

function RateLimits({setIsVisible}) {

  const [json, setjson] = useState(true);
    const [curl, setcurl] = useState(false);
    const [axios, setaxios] = useState(false);


    const click = (name) =>{
        
        console.log(name);
        switch (name) {
            case 'json':
                setjson(true);
                setcurl(false);
                setaxios(false);
              break;
            case 'curl':
                setjson(false);
                setcurl(true);
                setaxios(false);
              break;
            case 'axios':
                setjson(false);
                setcurl(false);
                setaxios(true);
              break;
          }
          
    }

    const response = null;
    const text1 = "Headers via SheildScan endpoint";
    const text2 = "Headers via RapidAPI endpoint";
    const body1 = `
      X-RateLimit-Limit: 1000
      X-RateLimit-Remaining: 998
      `
    const body2 = `
      x-ratelimit-requests-limit: 40
      x-ratelimit-requests-remaining: 1
      `

     // ******************* Observe if the component is loaded in the viewport **************

     const targetRef = useRef(null);
  
     useEffect(() => {
       const observer = new IntersectionObserver(
         ([entry]) => {
           // entry.isIntersecting is true when the target element is visible
           if(entry.isIntersecting){
              setIsVisible("ratelimits");
           }
         },
         {
           root: null, // use the viewport as the root
           rootMargin: '0px', // no margin
           threshold: 0.5, // 0.5 means at least 50% of the target element must be visible
         }
       );
   
       if (targetRef.current) {
         observer.observe(targetRef.current);
       }
   
       // Cleanup the observer when the component is unmounted
       return () => {
         if (targetRef.current) {
           observer.unobserve(targetRef.current);
         }
       };
     }, []);

    return (
        <div ref={targetRef} id='ratelimits'>
            <div className='docs_side_text'>
                <h1>🚦 Rate Limiting</h1>
                <p>SheildScan API uses sliding window algorithm for rate limiting.</p>
                <p>Depending on your subscription, limits are placed on the number of API 
                    requests you may make using your API key per 30-days. 
                    All responses from the API contain information about remaining 
                    and total rate limit. The special <code>X-RateLimit-headers </code>
                     have the following meaning:
                </p>
                <table>
                    <thead>
                        <tr>
                        <th>Header</th>
                        <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td><code>X-RateLimit-Limit</code><br/><br/><code>X-RateLimit-Limit</code></td>
                        <td>The number of requests per month for the plan you are currently subscribed to</td>
                        </tr>
                        <tr>
                        <td><code>X-RateLimit-Remaining</code><br/><br/><code>x-ratelimit-requests-remaining</code></td>
                        <td>The number of requests remaining before you reach the limit of requests your application is allowed to make</td>
                        </tr>
                        <tr>
                        <td><code>x-ratelimit-requests-reset</code></td>
                        <td>Time at which the requests counter is reset. Available only for RapidAPI endpoint only</td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <p>If you exceed this limit, your application will not be able to make any more requests until the rate limit is reset.</p>
                <br/>
                <div className='grey_box'>
                    <h2>ℹ️ How Do I See My Current Usage?</h2>
                    <h1>Besides the above headers, you can see your API usage via RapidAPI Developer dashboard and SheildScan Dashboard according to your subscription.</h1>
                </div>
            </div>
            <div className='ratelimits_side_code'>
            <div className='ratelimits_code_box'>
                    <div className='Code_snippet_lang'>
                        <div className={json ? 'active_lang': 'lang'} onClick={() => click('json')}>
                            <h1>Json</h1>
                        </div>
                        <div className={curl ? 'active_lang': 'lang'} onClick={() => click('curl')} >
                            <h1>cURL</h1>
                        </div>
                        <div className={axios ? 'active_lang': 'lang'} onClick={() => click('axios')} >
                            <h1>Axios</h1>
                        </div>
                    </div>
                    <CodeBlock body={body1} response={response} displayres={false} text={text1} />
                    <CodeBlock body={body2} response={response} displayres={false} text={text2}/>
                </div>
            </div>
        </div>   
    )
}

export default RateLimits
